import axios from "axios";
import { CreateAddressType } from "../pages/types/CreateAddressType";

export const createAddress = (
  addressDetails: CreateAddressType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.customer_address`,
      {
        params: {
          context: {},
          data: addressDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
